document.addEventListener("DOMContentLoaded", function() {

	const $ = jQuery.noConflict(),
		win = $(window).width(),
		d = new Date(),
		n = d.getFullYear(),
		page = $('html, body'),
		pageUrl = window.location.href,
		i = 0;

	$('.foo__copy em').text(n).addClass('foo__copy-year');

	// WP Remove <p> tags
	$('div.row p:empty').hide();
	$('div.row p').each(function() {
		var $this = $(this);
		if ($this.html() === "&nbsp;") {
			$this.remove();
		}
	});

    /**
     * HTML Popup
     */
    const popupTrigger = document.querySelector('.open-popup-link');
    const popup = document.querySelector('.mfp-hide');

    if (popupTrigger && popup) {
        $('.open-popup-link').on('click', function (e) {
            $('.mfp-hide').addClass('mfp-show');
            $('body').append('<div class="overlay open"></div>');
        })
        $('body').on('click', '.overlay', function (e) {
            $('.mfp-hide').removeClass('mfp-show');
            $(this).remove(); // removes overlay completely
        });
    }

        /**
	* Menu Scroll
	*/
	$('.site-header').removeClass('sticky-header');
	
	const lastScrollTop = 500;
	
	$(window).scroll(function(e) {    
		const scroll = $(window).scrollTop();
		const st = $(this).scrollTop();
		lastScrollTop = st;

		if (scroll >= 500) {
			$('.scroll-up').removeClass('hidden');
			$('.site-header').addClass('sticky-header');
		} else {
			$('.scroll-up').addClass('hidden');
			$('.site-header').removeClass('sticky-header');
		}
	});

	/**
	 * Mobile Menu Toggle
	 */
	$(document).on('click','.navbar-toggler-btn', function() {
		$('body').toggleClass("menu-open");
	});

	$('.bt-close').on('click', function() {
		$('.modal').modal('hide');
	});

	$('.header-nav-overlay').on('click', function() {
		$('.navbar-toggler-btn').trigger('click');
	});
''
	$(window).resize(function () {
		$('.navbar-nav input').prop('checked', false);
	});

	//$('.navbar-nav .nav-shop, .navbar-nav .nav-resources, .navbar-nav .nav-about').addClass('fancybox-inline');

	$('.site-header .navbar-nav>.menu-item a').each(function() {
		const target = $(this).attr('href');
		if( pageUrl === target ) {
			$(this).parent('.nav-item').addClass('menu-item-current');
		} else {
			$(this).parent('.nav-item').removeClass('menu-item-current');
		}
	});

	$('.wpcf7-select, .acf-form select, .filter-posts select, .wc-block-catalog-sorting .orderby, .wc-block-components-sort-select__select, .wc-block-product-categories__dropdown select').select2( { minimumResultsForSearch: 20 } );

	$('body').on('wpcf7-field-groups/added', function(e, g) {
		let $select = $(g).find('.wpcf7-select');
		$select.each(function(i, select) {
			$(select).removeClass('select2-hidden-accessible')
				.removeAttr('data-select2-id')
				.siblings('.select2-container').remove();
			$(select).select2({ minimumResultsForSearch: 20 });
		});
	});

	// $('.uk-repairs select').select2("enable", false);

	const postTitle = $("meta[property='og:title']").attr("content");
	const postContent = postTitle + ' - ' + pageUrl;

	$('.bssbSocialShare li.icon[data-social="mail"]').click(function() {
		window.location = "mailto:?subject=" + postTitle + "&body=" + postContent;
	});

	// Remove empty p & style tags
	$('div').each(function() { 
		if ( $(this).attr('style') === '' )  { 
			$(this).removeAttr('style')
		}
	});

	$(".img-cover img").each(function(i, elem) {
		const h = $(this).parents('.img-cover').siblings().height() + 200;
		const img = $(elem);
		img.css("height",h);
	});

	/**
	 * Form Range field
	 */
	const rangeSlider = function() {

		const slider = $('.range-slider'),
			range = $('.range-slider__range'),
			value = $('.range-slider__value');
		
		slider.each(function() {
	
			value.each(function(){
				const value = $(this).prev().attr('value');
				$(this).html(value).val(value);
			});
		
			range.on('input', function(){
				$(this).next(value).html(this.value);
				$(this).attr('value',this.value);
			});
		});
	};
	//rangeSlider();
});

function shuffleRetailers() {
	const modal = document.querySelector('#stores-modal');

	const retailers = Array.from(
		modal.querySelectorAll('.wp-block-wp-row-section')
	);

	// Retailers shuffle
	for (let i = retailers.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));

		[retailers[i], retailers[j]] = [retailers[j], retailers[i]];
	}

	retailers.forEach((item, index) => {
		if (index < 5) {
			modal.appendChild(item);
		} else {
			item.remove();
		}
	});
}

document.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('#stores-modal')) {
		shuffleRetailers();
	}
});